import {Component, OnInit, AfterViewInit, Renderer2, OnDestroy} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RoutePartsService } from './shared/services/route-parts.service';
import { ThemeService } from './shared/services/theme.service';
import { filter } from 'rxjs/operators';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { urpiweb } from './shared/helpers/constants';
import { GraphWindowsService } from './service/graph-windows.service';

@Component({
  selector: 'app-root', 
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  appTitle = 'Urpi Web';
  pageTitle = '';

  loggedIn: boolean;
  public userInfo: any = null;

  constructor(private _title: Title,
              private _router: Router,
              private _activeRoute: ActivatedRoute,
              private _routePartsService: RoutePartsService,
              private _themeService: ThemeService,
              private _renderer: Renderer2,
              private _adalSvc: MsAdalAngular6Service,
              private _graphWindowsService: GraphWindowsService) {      
        this.obtenerToken(); 
    }

  ngOnInit() {
    this.changePageTitle();
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
    this._themeService.applyMatTheme(this._renderer);
  }

  obtenerToken() {  
    var userInfo = this._adalSvc.userInfo;
    if(userInfo != null) {
      var res = this._adalSvc.GetResourceForEndpoint("https://graph.windows.net");       
      this._adalSvc.acquireToken(res).subscribe((token: string) => {
        urpiweb.auth.token = token;
      });
    }   
  }

  changePageTitle() {
    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      var routeParts = this._routePartsService.generateRouteParts(this._activeRoute.snapshot);
      if (!routeParts.length)
        return this._title.setTitle(this.appTitle);
      // Extract title from parts;
      this.pageTitle = routeParts
                      .reverse()
                      .map((part) => part.title )
                      .reduce((partA, partI) => {return `${partA} > ${partI}`});
      this.pageTitle += ` | ${this.appTitle}`;
      this._title.setTitle(this.pageTitle);
    });
  }
}
